import { List, fromJS } from 'immutable';

export function request(state, { userId, betUid, data }) {
    let bets = state.get('bets');
    let userBets = bets.get(userId);
    let betIndex = userBets.findIndex(x => x.get('uid') === betUid);

    if (data.stakePerLine === 0) {
        data.potentialReturns = 0;
        data.potentialReturnsAt = 0;
    }

    if (betIndex !== -1) {
        userBets = userBets.set(
            betIndex,
            userBets.get(betIndex)
                .merge(fromJS(data))
                .set('potentialReturns', data.potentialReturns)
        );
    }

    return state
        .set('bets', bets.set(userId, userBets));
}
